import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { BottomNav } from '@/components/common/BottomNav';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { LoginPage } from '@/components/auth/LoginPage';
import { ClosetPage } from '@/components/closet/ClosetPage';
import { GarmentDetail } from '@/components/closet/GarmentDetail';
import { TryOnPage } from '@/components/tryon/TryOnPage';
import { PlannerPage } from '@/components/planner/PlannerPage';
import { EventDetail } from '@/components/planner/EventDetail';
import { AnalyticsDashboard } from '@/components/planner/AnalyticsDashboard';
import { DiscoverPage } from '@/components/discover/DiscoverPage';
import { ProfileView } from '@/components/discover/ProfileView';
import { SearchView } from '@/components/discover/SearchView';
import { ProfilePage } from '@/components/profile/ProfilePage';
import { useAuthStore } from '@/stores/authStore';
import { initTheme, onSystemThemeChange } from '@/utils/theme';

export default function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  // Initialize theme on app load and listen for system changes
  useEffect(() => {
    initTheme();
    return onSystemThemeChange();
  }, []);

  return (
    <div className="relative min-h-full max-w-lg mx-auto bg-vestir-white flex flex-col">
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route element={<AuthGuard />}>
            <Route path="/closet" element={<ClosetPage />} />
            <Route path="/closet/:id" element={<GarmentDetail />} />
            <Route path="/tryon" element={<TryOnPage />} />
            <Route path="/mirror" element={<Navigate to="/tryon" replace />} />
            <Route path="/planner" element={<PlannerPage />} />
            <Route path="/planner/event/:id" element={<EventDetail />} />
            <Route path="/planner/analytics" element={<AnalyticsDashboard />} />
            <Route path="/discover" element={<DiscoverPage />} />
            <Route path="/discover/search" element={<SearchView />} />
            <Route path="/discover/profile/:id" element={<ProfileView />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>

          <Route
            path="*"
            element={
              <Navigate to={isAuthenticated ? '/closet' : '/login'} replace />
            }
          />
        </Routes>
      </AnimatePresence>

      {isAuthenticated && <BottomNav />}
    </div>
  );
}
